import React from "react";
import "../../styles.css";
import "./whatwedo.css";
import { useWhatWeDoSection } from "../../hooks/aboutSectionHooks";
import { urlFor } from "../../lib/sanity";

const WhatWeDoSection = () => {
  const { title, subtitle, description, items, loading, error } =
    useWhatWeDoSection();

  if (loading) {
    return (
      <section className="whatwedo">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center py-5">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }

  if (error) {
    return (
      <section className="whatwedo">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center py-5">
              <div className="alert alert-danger" role="alert">
                Error: {error}
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }

  if (!items || items.length === 0) {
    return null;
  }

  return (
    <section className="whatwedo">
      <div className="container">
        <div className="row">
          {/* what we do */}
          <div className="col-md-12 col-lg-5 my-auto py-5">
            <h3>{title}</h3>
            <div className="subtitle">
              <h1>{subtitle}</h1>
            </div>

            <div className="mb-0">
              <p>{description}</p>
            </div>
          </div>
          <div className="col-md-12 col-lg-7">
            {items.map((item, index) => (
              <div
                key={item.title + index}
                className="row align-items-center mb-3"
              >
                <div className="col-md-2">
                  <div className={index !== 0 ? "circle2" : "circle"}>
                    <img
                      src={urlFor(item.icon).url()}
                      className="img-flui"
                      alt={item.title}
                    />
                  </div>
                </div>

                <div className="col-md-10 px-lg-0 px-3 mt-lg-0 mt-2">
                  <div className="row mt-2">
                    <div className="col-7 ">
                      <h5>{item.title}</h5>
                      <p className="mt-0 mb-4">{item.description}</p>
                    </div>
                    <div className="col-5 counter mt-3">
                      <h2 className="">{item.count}+</h2>
                    </div>
                  </div>

                  <hr className="whatwedoline" />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhatWeDoSection;
